/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * An enumeration.
 */
export const ListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetStep =
  {
    EightySixThousandFourHundred: 86400,
    ThreeThousandSixHundred: 3600,
  } as const;
/**
 * An enumeration.
 */
export type ListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetStep =
  ClosedEnum<
    typeof ListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetStep
  >;

export type ListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetRequest =
  {
    ledgerCanisterId: string;
    start?: number | undefined;
    end?: number | undefined;
    /**
     * An enumeration.
     */
    step?:
      | ListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetStep
      | undefined;
    accountId?: string | undefined;
  };

/** @internal */
export const ListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetStep$inboundSchema:
  z.ZodNativeEnum<
    typeof ListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetStep
  > = z.nativeEnum(
    ListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetStep,
  );

/** @internal */
export const ListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetStep$outboundSchema:
  z.ZodNativeEnum<
    typeof ListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetStep
  > =
    ListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetStep$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetStep$ {
  /** @deprecated use `ListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetStep$inboundSchema` instead. */
  export const inboundSchema =
    ListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetStep$inboundSchema;
  /** @deprecated use `ListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetStep$outboundSchema` instead. */
  export const outboundSchema =
    ListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetStep$outboundSchema;
}

/** @internal */
export const ListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetRequest$inboundSchema:
  z.ZodType<
    ListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    ledger_canister_id: z.string(),
    start: z.number().int().optional(),
    end: z.number().int().optional(),
    step:
      ListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetStep$inboundSchema
        .default(86400),
    account_id: z.string().optional(),
  }).transform((v) => {
    return remap$(v, {
      "ledger_canister_id": "ledgerCanisterId",
      "account_id": "accountId",
    });
  });

/** @internal */
export type ListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetRequest$Outbound =
  {
    ledger_canister_id: string;
    start?: number | undefined;
    end?: number | undefined;
    step: number;
    account_id?: string | undefined;
  };

/** @internal */
export const ListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetRequest$outboundSchema:
  z.ZodType<
    ListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetRequest$Outbound,
    z.ZodTypeDef,
    ListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetRequest
  > = z.object({
    ledgerCanisterId: z.string(),
    start: z.number().int().optional(),
    end: z.number().int().optional(),
    step:
      ListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetStep$outboundSchema
        .default(86400),
    accountId: z.string().optional(),
  }).transform((v) => {
    return remap$(v, {
      ledgerCanisterId: "ledger_canister_id",
      accountId: "account_id",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetRequest$ {
  /** @deprecated use `ListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetRequest$inboundSchema` instead. */
  export const inboundSchema =
    ListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetRequest$inboundSchema;
  /** @deprecated use `ListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetRequest$outboundSchema` instead. */
  export const outboundSchema =
    ListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetRequest$outboundSchema;
  /** @deprecated use `ListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetRequest$Outbound` instead. */
  export type Outbound =
    ListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetRequest$Outbound;
}

export function listTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetRequestToJSON(
  listTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetRequest:
    ListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetRequest,
): string {
  return JSON.stringify(
    ListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetRequest$outboundSchema
      .parse(
        listTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetRequest,
      ),
  );
}

export function listTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  ListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'ListTransactionVolumeApiV1LedgersLedgerCanisterIdTransactionVolumeGetRequest' from JSON`,
  );
}
